import { Permission } from 'lib/enum/permission.enum';
import { Role } from 'lib/types/role-type';
import { ROLE_PERMISSIONS_MAP } from 'lib/utils/role.utils';
import { Context } from './Context.enum';
import { resolveEffectiveRole } from './EffectiveRoleResolver';
export const hasPermissionInContext = (
    userRoles: Map<Context, Role>,
    context: Context,
    permission: Permission,
): boolean => {
    const effectiveRole = resolveEffectiveRole(userRoles, context).role;

    return !!ROLE_PERMISSIONS_MAP.get(effectiveRole.id)?.has(permission);
};
